import { render, staticRenderFns } from "./LyoutYy.vue?vue&type=template&id=40d6a4d0&"
import script from "./LyoutYy.vue?vue&type=script&lang=js&"
export * from "./LyoutYy.vue?vue&type=script&lang=js&"
import style0 from "./LyoutYy.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports